import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';
import { DashboardComponent } from './shared/dashboard/dashboard.component';
import { environment } from '../environments/environment';
import { SampleApplicationComponent } from './sample-application/sample-application.component';
import { dashboardGuard } from './shared/dashboard/dashboard.guard';
import { ExtranetModule } from './shared/modules-access/extranet-module.enum';
import { moduleGuard } from './shared/modules-access/module.guard';
import { logisticsPermissionGuard } from './shared/modules-access/logistics-permission.guard';
import { cookieConsentGuard } from './guards/cookie-consent.guard';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { NoAccessPageComponent } from './shared/dashboard/no-access-page/no-access-page.component';
import { ChangePasswordPageComponent } from './change-password-page/change-password-page.component';
import { activeLanguageKey } from './config/language.config';
import { TokenBaselinkerPageComponent } from './token-baselinker-page/token-baselinker-page.component';
import { DummyRedirectComponent } from './dummy-redirect-component';

export let routes: Routes = [
  {
    path: 'cookie-consent',
    component: CookieConsentComponent
  },
  {
    path: 'login',
    component: LoginPageComponent,
    canActivate: [cookieConsentGuard]
  },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [cookieConsentGuard, dashboardGuard],
    children: [
      {
        path: '',
        canActivate: [moduleGuard],
        component: DummyRedirectComponent
      },
      {
        path: 'password',
        component: ChangePasswordPageComponent,
        canActivate: [moduleGuard],
        data: {
          moduleType: ExtranetModule.All
        },
      },
      {
        path: 'shipment/baselinker-token',
        component: TokenBaselinkerPageComponent,
        canActivate: [moduleGuard],
        data: {
          moduleType: ExtranetModule.All
        },
      },
      {
        path: 'shipment',
        loadChildren: () =>
          import('@kns-jasfbg/feature-shipment').then(
            module => module.FeatureShipmentModule
          ),
        data: {
          shipmentApiUrl: environment.shipmentApiUrl,
          consentApiUrl: environment.gatewayUrl,
          changePasswordUrl: environment.authConfig.issuer + '/Manage/ChangePassword',
          language: localStorage.getItem(activeLanguageKey) || 'pl',
          moduleType: ExtranetModule.Shipment
        },
        canActivate: [moduleGuard]
      },

      {
        path: 'agencies',
        loadChildren: () =>
          import('@jas-fbg-sa/feature-agencies').then(
            (module) => module.FeatureAgenciesModule
          ),
        data: {
          agenciesApiUrl: environment.agenciesApiUrl,
          moduleType: ExtranetModule.Agencies
        },
        canActivate: [moduleGuard]
      },

      {
        path: 'settlements',
        loadChildren: () =>
          import('@jas-fbg-sa/feature-settlements').then(
            (module) => module.FeatureSettlementsModule
          ),
        data: {
          settlementsApiUrl: environment.settlementsApiUrl,
          moduleType: ExtranetModule.Settlements
        },
        canActivate: [moduleGuard]
      },

      {
        path: 'logistics',
        loadChildren: () =>
          import('@jas-fbg-sa/feature-logistics').then(
            (module) => module.FeatureLogisticsModule
          ),
        data: {
          logisticsDocumentsApiUrl: environment.logisticsDocumentsApiUrl,
          moduleType: ExtranetModule.Logistics
        },
        canActivate: [moduleGuard],
        canActivateChild: [logisticsPermissionGuard]
      },

      {
        path: 'sample-application',
        component: SampleApplicationComponent,
        data: {
          moduleType: ExtranetModule.SampleApplication
        },
        canActivate: [moduleGuard]
      },
      {
        path: 'no-access',
        component: NoAccessPageComponent
      },

      {
        path: 'admin-panel',
        loadChildren: () =>
          import('@kns-jasfbg/users').then(
            (module) => module.UsersLibExtranetModule
          ),
        data: {
          extranetGatewayUrl: environment.gatewayUrl,
          consentsApiUrl: environment.gatewayUrl,
          moduleType: ExtranetModule.Users
        },
        canActivate: [moduleGuard]
      },
      {
        path: 'archive',
        loadChildren: () =>
          import('@kns-jasfbg/notifications').then(
            (module) => module.NotificationsLibExtranetModule
          ),
        data: {
          extranetGatewayUrl: environment.gatewayUrl,
          consentsApiUrl: environment.gatewayUrl,
          moduleType: ExtranetModule.All
        },
        canActivate: [moduleGuard]
      },
      ...(environment.enableFeatureHelp ? [{
        path: 'help',
        loadChildren: () =>
          import('@jas-fbg-sa/feature-help').then(
            (module) => module.FeatureHelpModule
          ),
        data: {
          helpApiUrl: environment.helpApiUrl,
          moduleType: ExtranetModule.All
        },
        canActivate: [moduleGuard]
      }] : []),
      ...(environment.enableFeatureComplaints ? [{
        path: 'complaints',
        loadChildren: () =>
          import('@kns-jasfbg/feature-complaints').then(
            (module) => module.FeatureComplaintsModule
          ),
        data: {
          moduleType: ExtranetModule.All
        },
        canActivate: [moduleGuard]
      }] : [])
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
